export const RECORD_TYPES = {
  ARTICLE: 'article',
  PRODUCT: 'product'
};

export const RECORD_SUBTYPES = {
  CLOTHING: 'clothing',
  SNEAKER: 'sneaker'
};
